/**
 * Service layer — Sheet Draft Assignments
 *
 * Who's drafting a drawing sheet, for visibility only (docs/QC_WORKFLOW.md). Not a RASCI
 * revival and not an access gate — AlderQC's own drafter role is open to anyone regardless of
 * whether a sheet carries an assignment (see services/qcVersions.js / the `qc-checker` module
 * for the actual checker gate). One assignee per sheet revision.
 *
 * Wraps /api/sheet-assignments. Callers never call it directly.
 */

const BASE = '/api/sheet-assignments'

async function authedFetch(url, opts = {}) {
  const token = window.__clerkGetToken ? await window.__clerkGetToken() : null
  const res = await fetch(url, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}), ...(opts.headers || {}) },
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || 'Request failed')
  return json
}

/**
 * @param {string[]} revisionIds — Sheet Revision record ids
 * @returns {Promise<Object<string, {sheetRevisionId, drawingSheetId, memberAirtableId, memberName, assignedByName, assignedAt}>>}
 */
export function getSheetDraftAssignments(revisionIds) {
  const ids = [...new Set((revisionIds || []).filter(Boolean))]
  if (!ids.length) return Promise.resolve({})
  return authedFetch(BASE + '?revisionIds=' + encodeURIComponent(ids.join(',')))
    .then(j => j.assignments || {})
}

export function setSheetDraftAssignment(sheetRevisionId, drawingSheetId, memberAirtableId, memberName, actorMemberId, actorName) {
  return authedFetch(BASE, {
    method: 'POST',
    body: JSON.stringify({ action: 'set', sheetRevisionId, drawingSheetId, memberAirtableId, memberName, actorMemberId, actorName }),
  }).then(j => j.assignment)
}

export function clearSheetDraftAssignment(sheetRevisionId) {
  return authedFetch(BASE, { method: 'POST', body: JSON.stringify({ action: 'clear', sheetRevisionId }) })
}
